import { combineReducers } from "redux";

import effect from "../features/admin/effects/effect/Slice";

import product from "../features/admin/effects/product/Slice";

import common from "../features/admin/common/Slice";

const effects = combineReducers({
    effect,
    product,
    common
});

export default effects;